musicManager = {};
musicManager.idle = true;
musicManager.inFreespins = false;
musicManager.wasInFreeSpins = false;
musicManager.inBaseGameModifier = false;
musicManager.musicLevel = 1;

musicManager.ALLOFFLEVEL = [false, false, false, false];
musicManager.IDLELEVEL = [true, false, false, false];
musicManager.SPINLEVEL = [false, true, false, false];
musicManager.SINGLEWINLEVEL = [false, false, true, false];
musicManager.MULTIWINLEVEL = [false, false, false, true];

musicManager.FREESPINS_ALLOFF = [false, false, false, false];
musicManager.FREESPINS_BASE = [true, false, false, false];
musicManager.FREESPINS_LEVEL1 = [false, true, false, false];
musicManager.FREESPINS_LEVEL2 = [false, false, true, false];

// Base
musicManager.soundsToFadeOut = [];
musicManager.soundsToFadeIn = [];

musicManager.stepDownTimer = undefined;

// Freespins
musicManager.soundsToFadeOutFS = [];
musicManager.soundsToFadeInFS = [];

//Bonus
musicManager.cloverRespinsPlaying = false;
musicManager.goldenSpinsPlaying = false;
musicManager.potCollectPlaying = false;
musicManager.previousPotLevel = undefined;
musicManager.bigWinWon = false;

musicManager.initialise = function () {
  musicManager.volume = 0;
  musicManager.playing = false;
  musicManager.soundTags = soundManager.soundsConfig.tags;

  musicManager.fadeBaseTimeIn = 0.5;
  musicManager.fadeBaseTimeOut = 0.5;
  musicManager.fadeIdleThemeIn = 2;
  musicManager.fadeIdleThemeOut = 2;

  musicManager.fadeBigWinTimeIn = 0.25;
  musicManager.fadeBigWinTimeOut = 0.25;

  musicManager.fadeSymWinTimeIn = 0.3;
  musicManager.fadeSymWinTimeOut = 0.3;

  musicManager.maxMusicVolume = 0.65;
  musicManager.anticipationFade = 0.2;
  musicManager.anticipationTime = 0.2;
  musicManager.currentTheme = undefined;
  musicManager.stepDownDuration = 8000;

  musicManager.baseMusic = ["gameTheme0", "gameTheme1", "gameTheme2", "gameTheme3"];

  musicManager.basePlaying = [false, false, false, false];

  musicManager.baseID = [];

  musicManager.baseGameLevel = musicManager.ALLOFFLEVEL;
  musicManager.freeSpinsLevel = musicManager.FREESPINS_ALLOFF;

  musicManager.freeSpinsMusic = ["freeSpinsLoop0", "freeSpinsLoop1", "freeSpinsLoop2"];

  musicManager.fsPlaying = [false, false, false, false];

  musicManager.freeSpinsID = [];
  musicManager.previouslyPlayingBeforeFade = [];

  messageBus.subscribe("sounds:restorePreviouslyPlayingAudio", musicManager.onRestorePreviouslyPlayingAudio);
  messageBus.subscribe("game:goingToReplay", musicManager.onGoingToReplay);
};

musicManager.onGameLoaded = function () {
  // setup base music tracks - all volumes 0
  for (var i = 0; i < musicManager.baseMusic.length; i++) {
    musicManager.baseID.push(soundManager.play(musicManager.baseMusic[i]));
    soundManager.setVolume(0, musicManager.baseID[i]);
  }

  // setup free spins music tracks - all volumes 0
  for (var j = 0; j < musicManager.freeSpinsMusic.length; j++) {
    musicManager.freeSpinsID.push(soundManager.play(musicManager.freeSpinsMusic[j]));
    soundManager.setVolume(0, musicManager.freeSpinsID[j]);
  }

  musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
};

musicManager.onSymbolWinlineStart = function () {
  if (musicManager.inFreespins) {
    musicManager.previouslyPlayingBeforeFade = musicManager.fsPlaying;
    musicManager.fadeFSLevels(
      musicManager.FREESPINS_ALLOFF,
      musicManager.fadeSymWinTimeIn,
      musicManager.fadeSymWinTimeOut
    );
  } else {
    musicManager.previouslyPlayingBeforeFade = musicManager.basePlaying;
    musicManager.fadeLevels(musicManager.ALLOFFLEVEL, musicManager.fadeSymWinTimeIn, musicManager.fadeSymWinTimeOut);
  }
};

musicManager.onSymbolWinlineEnd = function () {
  if (musicManager.inFreespins) {
    musicManager.fadeFSLevels(
      musicManager.previouslyPlayingBeforeFade,
      musicManager.fadeSymWinTimeIn,
      musicManager.fadeSymWinTimeIOut
    );
  } else {
    musicManager.fadeLevels(
      musicManager.previouslyPlayingBeforeFade,
      musicManager.fadeSymWinTimeIn,
      musicManager.fadeSymWinTimeOut
    );
  }
  musicManager.previouslyPlayingBeforeFade = [];
};

musicManager.onGameStart = function () {
  if (gameData.credit >= resourceManager.getController("stakeController").CurrentStake) {
    timerManager.stop(musicManager.stepDownTimer);
    musicManager.idle = false;

    if (!musicManager.playing && !musicManager.inFreespins) {
      musicManager.playing = true;
      soundManager.play("reelSpin");
      if (musicManager.basePlaying === musicManager.IDLELEVEL) {
        if (musicManager.bigWinWon) {
          musicManager.fadeLevels(
            musicManager.MULTIWINLEVEL,
            musicManager.fadeBigWinTimeIn,
            musicManager.fadeBigWinTimeOut
          );
          musicManager.bigWinWon = false;
        } else {
          musicManager.fadeLevels(musicManager.SPINLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
        }
      }
    }
  }
};

musicManager.checkThemeLevel = function () {
  return musicManager.basePlaying.findIndex((level) => level === true);
};

musicManager.onGameEnd = function () {
  musicManager.idle = true;
  musicManager.playing = false;

  musicManager.setStepDownTimer();
};

musicManager.fadeForAnticipation = function () {
  let levels = musicManager.inFreespins ? musicManager.freeSpinsLevel : musicManager.basePlaying;
  let themeArray = musicManager.inFreespins ? musicManager.freeSpinsID : musicManager.baseID;
  const index = levels.findIndex((playing) => playing === true);

  musicManager.currentTheme = themeArray[index];
  soundManager.anticipationCancelled = false;
  console.log(musicManager.currentTheme);
  soundManager.fade(musicManager.anticipationFade, musicManager.anticipationTime, musicManager.currentTheme, () => {
    if (soundManager.anticipationCancelled) return;
    soundManager.play("reelAnticipation");
  });
};

musicManager.onAnticipationEnd = function () {
  let levels = musicManager.inFreespins ? musicManager.freeSpinsLevel : musicManager.basePlaying;
  let themeArray = musicManager.inFreespins ? musicManager.freeSpinsID : musicManager.baseID;
  const index = levels.findIndex((playing) => playing === true);

  musicManager.currentTheme = themeArray[index];
  soundManager.fade(
    musicManager.maxMusicVolume,
    musicManager.anticipationTime,
    musicManager.currentTheme,
    () => {
      soundManager.stop("reelAnticipation");
    },
    true
  );
};

musicManager.stepDown = function () {
  if (musicManager.basePlaying === musicManager.MULTIWINLEVEL) {
    musicManager.stepDownTimer = timerManager.addTimer(3000, undefined, musicManager.stepDown);
    musicManager.fadeLevels(musicManager.SINGLEWINLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  } else if (musicManager.basePlaying === musicManager.SINGLEWINLEVEL) {
    musicManager.stepDownTimer = timerManager.addTimer(3000, undefined, musicManager.stepDown);
    musicManager.fadeLevels(musicManager.SPINLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  } else if (musicManager.basePlaying === musicManager.SPINLEVEL) {
    timerManager.stop(musicManager.stepDownTimer);
    musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  }
};

musicManager.playBigWin = function () {
  musicManager.bigWinID = soundManager.play("bigWinLoop");

  if (gameController.inFreeSpins) {
    musicManager.onFreespinsEnd();
  } else {
    musicManager.fadeLevels(musicManager.ALLOFFLEVEL, musicManager.fadeBigWinTimeIn, musicManager.fadeBigWinTimeOut);
  }
};

musicManager.endBigWin = function () {
  musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBigWinTimeIn, musicManager.fadeBigWinTimeOut);
  soundManager.fade(0, musicManager.fadeBaseTimeOut, musicManager.bigWinID, () => {
    soundManager.stop("bigWinLoop");
  });
  musicManager.bigWinWon = true;
};

musicManager.playCloverRespins = function () {
  if (!musicManager.cloverRespinsPlaying) {
    musicManager.cloverRespinsPlaying = true;
    musicManager.cloverSpinsID = soundManager.play("cloverSpinsLoop");
    musicManager.fadeLevels(musicManager.ALLOFFLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  }
};

musicManager.onCloverRespinsEnd = function () {
  musicManager.cloverRespinsPlaying = false;
  soundManager.fade(0, musicManager.fadeBaseTimeOut, musicManager.cloverSpinsID, () => {
    soundManager.stop("cloverSpinsLoop");
  });

  musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
};

musicManager.playGoldenSpins = function () {
  if (!musicManager.goldenSpinsPlaying) {
    musicManager.goldenSpinsID = soundManager.play("goldenSpinsLoop");
    musicManager.goldenSpinsPlaying = true;
    musicManager.preGoldenSpinsLevels = musicManager.fsPlaying;
    musicManager.fadeFSLevels(musicManager.ALLOFFLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  }
};

musicManager.onGoldenSpinsEnd = function () {
  musicManager.goldenSpinsPlaying = false;
  if (musicManager.goldenSpinsID) {
    soundManager.fade(0, musicManager.fadeBaseTimeOut, musicManager.goldenSpinsID, () => {
      soundManager.stop("goldenSpinsLoop");
    });

    musicManager.fadeFSLevels(
      musicManager.preGoldenSpinsLevels,
      musicManager.fadeBaseTimeIn,
      musicManager.fadeBaseTimeOut
    );
  }
};

musicManager.playPotCollect = function () {
  if (!musicManager.potCollectPlaying) {
    musicManager.potCollectID = soundManager.play("horseshoeLoop");
    musicManager.potCollectPlaying = true;
    if (musicManager.inFreespins) {
      if (musicManager.goldenSpinsPlaying) {
        soundManager.fade(0, musicManager.fadeBaseTimeOut, musicManager.goldenSpinsID, undefined);
      }
      musicManager.prePotLevels = musicManager.fsPlaying;
      musicManager.fadeFSLevels(
        musicManager.FREESPINS_LEVEL2,
        musicManager.fadeBaseTimeIn,
        musicManager.fadeBaseTimeOut
      );
    } else {
      if (musicManager.cloverRespinsPlaying) {
        soundManager.fade(0, musicManager.fadeBaseTimeOut, musicManager.cloverSpinsID, undefined);
      }
      musicManager.prePotLevels = musicManager.basePlaying;
      musicManager.fadeLevels(musicManager.MULTIWINLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
    }
  }
};

musicManager.onPotCollectEnd = function () {
  musicManager.potCollectPlaying = false;
  soundManager.fade(0, musicManager.fadeBaseTimeOut, musicManager.potCollectID, () => {
    soundManager.stop("horseshoeLoop");
  });
  if (musicManager.inFreespins) {
    if (musicManager.goldenSpinsPlaying) {
      soundManager.fade(0.5, musicManager.fadeBaseTimeOut, musicManager.goldenSpinsID, undefined);
    }
    musicManager.fadeFSLevels(musicManager.prePotLevels, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  } else {
    musicManager.fadeLevels(musicManager.prePotLevels, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  }
  if (musicManager.cloverRespinsPlaying) {
    soundManager.fade(0.5, musicManager.fadeBaseTimeOut, musicManager.cloverSpinsID, undefined);
  }
};

musicManager.fadeBigWin = function (newVolume) {
  soundManager.setVolume(newVolume, musicManager.bigWinID);
};

/////////////////////////////////
// Pass in 4 item array - with levels that need to be on and off )
// e.g. F,F,T,T will play levels 2 and 3 ( indexed from 0 )
////////////////////////
musicManager.fadeLevels = function (levels, fadeInTime, fadeOutTime) {
  // at end as we may not have a channel currently playing - musicManager.basePlaying = levels;
  musicManager.soundsToFadeOut = [];
  musicManager.soundsToFadeIn = [];

  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.basePlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeIn.push(musicManager.baseID[i]);
    } else if (levels[i] === false && musicManager.basePlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOut.push(musicManager.baseID[i]);
    }
  }

  for (var i = 0; i < musicManager.soundsToFadeIn.length; i++) {
    soundManager.fade(musicManager.maxMusicVolume, fadeInTime, musicManager.soundsToFadeIn[i], undefined);
  }

  for (var i = 0; i < musicManager.soundsToFadeOut.length; i++) {
    soundManager.fade(0, fadeOutTime, musicManager.soundsToFadeOut[i], undefined);
  }

  musicManager.basePlaying = levels;
};

musicManager.fadeFSLevels = function (levels, fadeInTime, fadeOutTime) {
  musicManager.soundsToFadeOutFS = [];
  musicManager.soundsToFadeInFS = [];

  for (var i = 0; i < levels.length; i++) {
    if (levels[i] === true && musicManager.fsPlaying[i] === false) {
      // we want to play but it's currently silent - fade in level
      musicManager.soundsToFadeInFS.push(musicManager.freeSpinsID[i]);
    } else if (levels[i] === false && musicManager.fsPlaying[i] === true) {
      // currently playing but make silent
      musicManager.soundsToFadeOutFS.push(musicManager.freeSpinsID[i]);
    }
  }

  for (var i = 0; i < musicManager.soundsToFadeInFS.length; i++) {
    soundManager.fade(musicManager.maxMusicVolume, fadeInTime, musicManager.soundsToFadeInFS[i], undefined);
  }

  for (var i = 0; i < musicManager.soundsToFadeOutFS.length; i++) {
    soundManager.fade(0, fadeOutTime, musicManager.soundsToFadeOutFS[i]);
  }

  musicManager.fsPlaying = levels;
};

musicManager.restartBaseMusic = function () {
  musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
};

musicManager.restartFreeSpins = function () {
  musicManager.fadeFSLevels(musicManager.freeSpinsLevel, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
};

musicManager.onFreespinsIntro = function () {
  timerManager.stop(musicManager.stepDownTimer);
  musicManager.fadeLevels(musicManager.ALLOFFLEVEL, musicManager.fadeBaseTimeIn, 0.5);
  musicManager.playing = false;
};

musicManager.onFreespinsStart = function () {
  // Here we stop the freespins intro music and play the freespins standard music
  // soundManager.fade(0, 1, musicManager.basePlaying);
  // musicManager.fadeLevels(musicManager.ALLOFFLEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  timerManager.stop(musicManager.stepDownTimer);
  musicManager.freeSpinsLevel = musicManager.FREESPINS_BASE;
  musicManager.fadeFSLevels(musicManager.freeSpinsLevel, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);

  musicManager.inFreespins = true;
  musicManager.playing = false;
};

musicManager.freeSpinsNextLevel = function (index) {
  var changed = false;
  if (index === 1) {
    if (musicManager.freeSpinsLevel !== musicManager.FREESPINS_LEVEL1) {
      musicManager.freeSpinsLevel = musicManager.FREESPINS_LEVEL1;
      changed = true;
    }
  }
  if (index === 2) {
    if (musicManager.freeSpinsLevel !== musicManager.FREESPINS_LEVEL2) {
      musicManager.freeSpinsLevel = musicManager.FREESPINS_LEVEL2;
      changed = true;
    }
  }

  if (changed) {
    musicManager.fadeFSLevels(musicManager.freeSpinsLevel, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
  }
};
musicManager.baseGameNextLevel = function (index) {
  let changed = false;
  let idle = false;
  let fadeIn = musicManager.fadeBaseTimeIn;
  let fadeOut = musicManager.fadeBaseTimeOut;
  if (index === 0) {
    if (musicManager.baseGameLevel !== musicManager.IDLELEVEL) {
      musicManager.baseGameLevel = musicManager.IDLELEVEL;
      changed = true;
      idle = true;
    }
  }
  if (index === 1) {
    if (musicManager.baseGameLevel !== musicManager.SINGLEWINLEVEL) {
      musicManager.baseGameLevel = musicManager.SINGLEWINLEVEL;
      changed = true;
    }
  }
  if (index === 2) {
    if (musicManager.baseGameLevel !== musicManager.MULTIWINLEVEL) {
      musicManager.baseGameLevel = musicManager.MULTIWINLEVEL;
      changed = true;
    }
  }
  if (idle) {
    fadeIn = musicManager.fadeIdleThemeIn;
    fadeOut = musicManager.fadeIdleThemeOut;
  }

  if (changed) {
    musicManager.fadeLevels(musicManager.baseGameLevel, fadeIn, fadeOut);
  }
};

musicManager.setStepDownTimer = function () {
  timerManager.stop(musicManager.stepDownTimer);
  if (musicManager.basePlaying === musicManager.SPINLEVEL) {
    musicManager.stepDownTimer = timerManager.addTimer(musicManager.stepDownDuration, undefined, () => {
      musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeIdleThemeIn, musicManager.fadeIdleThemeOut);
      musicManager.baseGameLevel = musicManager.IDLELEVEL;
    });
  } else if (musicManager.basePlaying === musicManager.SINGLEWINLEVEL) {
    musicManager.stepDownTimer = timerManager.addTimer(musicManager.stepDownDuration, undefined, () => {
      musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeIdleThemeIn, musicManager.fadeIdleThemeOut);
      musicManager.baseGameLevel = musicManager.IDLELEVEL;
    });
  } else if (musicManager.basePlaying === musicManager.MULTIWINLEVEL) {
    musicManager.stepDownTimer = timerManager.addTimer(musicManager.stepDownDuration, undefined, () => {
      musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeIdleThemeIn, musicManager.fadeIdleThemeOut);
      musicManager.baseGameLevel = musicManager.IDLELEVEL;
    });
  }
};

musicManager.onFreespinsEnd = function () {
  // Here we stop the freespins music. Normal music will be resumed upon next spin
  musicManager.inFreespins = false;
  musicManager.wasInFreeSpins = true;
  musicManager.fadeFSLevels(musicManager.FREESPINS_ALLOFF, musicManager.fadeBaseTimeIn, 0.5);

  musicManager.fadeLevels(musicManager.IDLELEVEL, musicManager.fadeBaseTimeIn, musicManager.fadeBaseTimeOut);
};

// musicManager.onPlayBubbleIntro = function () {
//   const bubbleIntroSound = soundManager.play('bubblesIntro');
//   timerManager.addTimeout(2200, function () {
//     soundManager.fade(0, 0.5, bubbleIntroSound);
//   });
// };

musicManager.setMusicLevel = function (level) {
  musicManager.musicLevel = level;
};

musicManager.update = function (delta) {
  // Are we playing a sound
  if (musicManager.inFreespins) return;
};

musicManager.onRestorePreviouslyPlayingAudio = function (data) {
  if (data.reason === "back from replay" && !Reflex.replayGame) {
    musicManager.ALLOFFLEVEL = [false, false, false, false];
    musicManager.IDLELEVEL = [true, false, false, false];
    musicManager.SPINLEVEL = [false, true, false, false];
    musicManager.SINGLEWINLEVEL = [false, false, true, false];
    musicManager.MULTIWINLEVEL = [false, false, false, true];

    musicManager.FREESPINS_ALLOFF = [false, false, false, false];
    musicManager.FREESPINS_BASE = [true, false, false, false];
    musicManager.FREESPINS_LEVEL1 = [false, true, false, false];
    musicManager.FREESPINS_LEVEL2 = [false, false, true, false];

    musicManager.currentTheme = undefined;
    musicManager.stepDownDuration = 8000;

    musicManager.baseMusic = ["gameTheme0", "gameTheme1", "gameTheme2", "gameTheme3"];

    musicManager.basePlaying = [false, false, false, false];

    musicManager.baseID = [];

    musicManager.baseGameLevel = musicManager.ALLOFFLEVEL;
    musicManager.freeSpinsLevel = musicManager.FREESPINS_ALLOFF;

    musicManager.freeSpinsMusic = ["freeSpinsLoop0", "freeSpinsLoop1", "freeSpinsLoop2"];

    musicManager.fsPlaying = [false, false, false, false];

    musicManager.freeSpinsID = [];
    musicManager.previouslyPlayingBeforeFade = [];

    soundManager.anticipationCancelled = true;
    soundManager.stop("reelAnticipation");
    musicManager.onGameLoaded();
    musicManager.stopAllTimers();
    musicManager.soundsToFadeOut = [];
    musicManager.soundsToFadeIn = [];
    musicManager.soundsToFadeOutFS = [];
    musicManager.soundsToFadeInFS = [];
  }
};

musicManager.stopAllTimers = function () {
  if (musicManager.stepDownTimer) {
    timerManager.stop(musicManager.stepDownTimer);
  }
};

musicManager.onGoingToReplay = function () {
  // this is where we need to
  const sp = gdk.getServerParser();
  if (sp.replayFromIframeGame === false) {
    musicManager.stopAllTimers();
  }
};

Reflex.addToUpdate(musicManager.update);

Reflex.registerInitialiseManager(musicManager.initialise);
